<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    custom-class="custom-scrollable"
  >
    <div>
      <p class="md:text-2xl text-center -mt-10 text-root-2 font-bold mb-3">
        Deposit Details
      </p>
    </div>
    <div>
      <deposit-information
        v-if="isInfoView && !isConfirmDeposit"
        @handleClose="handleClose"
        @next="next"
      />
      <deposit-only v-if="isDepositOnly" :selectedAsset="asset" />
      <deposit-confirmation
        v-if="isConfirmDeposit"
        @handleClose="handleClose"
      />
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: 'depositInfo'
    },
    asset: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      breakpoints,
      activeView: 'depositInfo'
    }
  },
  methods: {
    handleClose () {
      this.$emit('handleClose')
    },
    next () {
      this.activeView = 'confirmationView'
    }
  },
  components: {
    DepositInformation: () =>
      import(
        '@/components/v2/deposit/dialogs/assetDepositDetails/DepositInformation.vue'
      ),
    DepositConfirmation: () =>
      import(
        '@/components/v2/deposit/dialogs/assetDepositDetails/DepositConfirmation.vue'
      ),
    DepositOnly: () =>
      import(
        '@/components/v2/deposit/dialogs/assetDepositDetails/DepositOnly.vue'
      )
  },
  beforeMount () {
    this.activeView = this.view
  },
  computed: {
    isLocalDepositInfo () {
      return (
        this.$store.state.transactions.depositDetailsType === 'localTransfer'
      )
    },
    isWireTransferInternational () {
      return (
        this.$store.state.transactions.depositDetailsType ===
        'wireTransferInternational'
      )
    },
    isWireTransferUS () {
      return (
        this.$store.state.transactions.depositDetailsType === 'wireTransferUS'
      )
    },
    isInfoView () {
      return this.view === 'depositInfo'
    },
    isConfirmDeposit () {
      return (
        !(this.activeView === 'depositInfo') && !(this.view === 'depositOnly')
      )
    },
    isDepositOnly () {
      return this.activeView === 'depositOnly'
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 16px;
  padding: 5px;
  background-color: white;
}
>>> .el-dialog__close .el-icon .el-icon-close {
  color: black !important;
}
</style>
